import { FiltersValueKey, DepositLedgerFilterValues } from '../schema';

export const defaultDepositLedgerFilterValues: DepositLedgerFilterValues = {
    [FiltersValueKey.ownerTypes]: [],
    [FiltersValueKey.associatedAccountTypes]: [],
    [FiltersValueKey.reservationStates]: [],
    [FiltersValueKey.arrivalStart]: '',
    [FiltersValueKey.arrivalEnd]: '',
    [FiltersValueKey.balanceMin]: '',
    [FiltersValueKey.balanceMax]: '',
};
